import Marionette            from 'backbone.marionette';
import AccessoriesHolders    from 'scripts/defa/control/accessories-holder/collection-accessories-holders';
import AlarmCentrals         from 'scripts/defa/alarm-centrals/collection-alarm-centrals';
import AlarmSwitchs          from 'scripts/defa/control/home-main-switches/main-alarm-switch/collection-alarm-switchs';
import BatteryAlerts         from 'scripts/defa/control/home-alerts/battery-alert/collection-battery-alerts';
import Calendars             from 'scripts/defa/control/calendar/collection-calendars';
import DayAndNightSettings   from 'scripts/defa/control/day-and-night/collection-day-and-night-settings';
import DigiHeats             from 'scripts/defa/control/digiheat/collection-digiheats';
import Finders               from 'scripts/defa/control/map/collection-finders';
import FollowMainAlarms      from 'scripts/defa/control/general-alarm-switches/follow-main-alarm/collection-follow-main-alarms';
import GeneralAlarmInputs    from 'scripts/defa/control/general-alarm-switches/general-alarm-input/collection-general-alarm-inputs';
import GenericStates         from 'scripts/defa/control/generic-state/collection-generic-states';
import PickupTimes           from 'scripts/defa/control/pickup-times/collection-pickuptimes';
import PowerAlerts           from 'scripts/defa/control/home-alerts/power-alert/collection-power-alerts';
import WarmupStates          from 'scripts/defa/control/warmup-state/collection-warmupstates';
import WarmupSettings        from 'scripts/defa/control/warmup-settings/collection-warmup-settings';
import TemperatureAlerts     from 'scripts/defa/control/home-alerts/temperature-alert/collection-temperature-alerts';
import Securitys             from 'scripts/defa/control/security/collection-securitys';
import RecipientGroupHolders from 'scripts/defa/recipients/collection-recipientGroup-holders'
import NotificationHolders   from 'scripts/defa/control/notification-holders/collection-notification-holders';
import Customers             from 'scripts/defa/customers/collection-customers';
import InsuranceCompanies   from 'scripts/defa/insurance-companies/collection-insurance-companies';
import Invoices             from 'scripts/defa/invoices/collection-invoices';
import Usages               from 'scripts/defa/invoices/collection-usages';
import LegacyUser           from 'scripts/defa/legacy/model-legacy-user';
import HeatingSwitchs       from 'scripts/defa/control/home-main-switches/heating-switch/collection-heating-switchs';
import PhoneNumbers         from 'scripts/defa/phone-numbers/collection-phone-numbers';
import RoleApplications     from 'scripts/defa/role-applications/collection-role-applications';
import SearchResults        from 'scripts/defa/search-results/collection-search-results';
import SettingsAutomotives  from 'scripts/defa/settings-automotive/collection-settings-automotives';
import SettingsHomes        from 'scripts/defa/settings-home/collection-settings-homes';
import SubscriptionPackages from 'scripts/defa/subscription-packages/collection-subscription-packages';
import Subscriptions        from 'scripts/defa/subscriptions/collection-subscriptions';
import UnitFeatureSets      from 'scripts/defa/unit-feature-sets/collection-unit-feature-sets';
import Units                 from 'scripts/defa/units/collection-units';
import Users                 from 'scripts/defa/users/collection-users';
import Warmups               from 'scripts/defa/unit-feature-sets/endpoints/warmup/collection-warmups';
import ZoneHolders           from 'scripts/defa/control/zone-holder/collection-zone-holders';

const channelUser = Bb.Radio.channel( 'user' );

const opts = {
	collections  : {
		accessoriesHolders    : new AccessoriesHolders(),
		alarmCentrals         : new AlarmCentrals(),
		alarmSwitchs          : new AlarmSwitchs(),
		dayAndNightSettings   : new DayAndNightSettings(),
		customers             : new Customers(),
		calendars             : new Calendars(),
		digiHeatModes         : new DigiHeats(),
		finders               : new Finders(),
		followMainAlarms      : new FollowMainAlarms(),
		generalAlarmInputs    : new GeneralAlarmInputs(),
		invoices              : new Invoices(),
		insuranceCompanies    : new InsuranceCompanies(),
		heatingSwitchs        : new HeatingSwitchs(),
		phoneNumbers          : new PhoneNumbers(),
		settingsAutomotives   : new SettingsAutomotives(),
		settingsHomes         : new SettingsHomes(),
		subscriptions         : new Subscriptions(),
		subscriptionPackages  : new SubscriptionPackages(),
		units                 : new Units(),
		unitFeatureSets       : new UnitFeatureSets(),
		usages                : new Usages(),
		users                 : new Users(),
		ser                   : new SearchResults(),
		securitys             : new Securitys(),
		pickupTimes           : new PickupTimes(),
		warmupStates          : new WarmupStates(),
		warmupSettings        : new WarmupSettings(),
		recipientGroupHolders : new RecipientGroupHolders(),
		roleApplications      : new RoleApplications(),
		notificationHolders   : new NotificationHolders(),
		genericStates         : new GenericStates(),
		warmups               : new Warmups(),
		temperatureAlerts     : new TemperatureAlerts(),
		batteryAlerts         : new BatteryAlerts(),
		powerAlerts           : new PowerAlerts(),
		zoneHolders           : new ZoneHolders(),
	},
	models       : {
		legacyUser: new LegacyUser(),
	},
	initialize   : function ( options ) {
		this.options = options || {};
	},
	channelName  : 'objects',
	radioRequests: {
		'user': () => channelUser.request( 'model' )
	},
	populateFrom({units, phoneNumbers, customers}) {
		this.collections.units.add(units);
		this.collections.phoneNumbers.add(phoneNumbers);
		this.collections.customers.add(customers);
	}
};

for ( let key in opts.collections ) {
	// noinspection JSUnfilteredForInLoop
	opts.radioRequests[ key ] = () => opts.collections[ key ];
}

for ( let key in opts.models ) {
	// noinspection JSUnfilteredForInLoop
	opts.radioRequests[ key ] = () => opts.models[ key ];
}

const ObjectHandlerClass = Marionette.Object.extend( opts );

export const ObjectHandler = new ObjectHandlerClass();